import { GetSharedCandidatesRosterDataOutput } from '$store/modules/candidates';
import dayjs from 'dayjs';

const SPKExperienceCard = ({
  experience,
}: {
  experience: GetSharedCandidatesRosterDataOutput['candidates'][number]['CandidateWorkExperience'][number];
}) => {
  return (
    <div className="flex flex-col text-black/70">
      <p className="font-semibold text-black/90 mb-2">{experience.JobTitle}</p>
      <div className="pl-4">
        {/* <p className="flex items-center">
          <i className="pi pi-building text-base mr-2" />
          {experience.Company}
        </p> */}
        <p className="flex items-center">
          <i className="pi pi-calendar text-base mr-2" />
          {experience.Admission
            ? dayjs(experience.Admission).format('MMMM YYYY')
            : ''}{' '}
          -{' '}
          {experience.Egress
            ? dayjs(experience.Egress).format('MMMM YYYY')
            : 'present'}
        </p>
        <p className="mt-3">{experience.Description}</p>
      </div>
    </div>
  );
};

export default SPKExperienceCard;
